import React, { PureComponent } from 'react'
import { mapSelectorsToProps } from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { connect } from 'react-redux'
import { motion } from 'framer-motion'
import DrawerFader from 'aria-viewer/drawer/drawerFader'
import {
    STOP_FADER_DRAWER,
    HIDE_DRAWER,
    TOUR_DRAWER,
    showTourDrawer,
    hideDrawer,
    showStopFaderDrawer,
    stopListScrolled,
    stopListItemClicked,
    hideDrawerTriggers,
} from 'aria-viewer/drawer/drawerMenuActions'
import { setShowSearchAIPrompt } from 'aria-viewer/searchAIPrompt/searchAIPromptActions'
import Radium from 'radium'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { STOP_ANALYTICS_INITIATED_BY, TourActions } from 'aria-viewer/tour/constants/'
import { setStopInitiatedBy } from 'aria-viewer/analytics/analyticActions'
import { setStop } from 'aria-viewer/tour/tourActions'
import Button from 'aria-viewer/tour/components/buttons/button'
import Icon from 'aria-viewer/tour/components/icon'
import { MAIN_SCENE_ITEM_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import ReactIScroll from 'react-iscroll'
import colors from 'aria-viewer/tour/constants/style/colors'
import PERSONALIZED_STARS from 'public/assets/svg/personalized_stars.svg'
import SEARCH_ICON from 'public/assets/svg/icons/icon_search.svg'
import iScroll from 'iscroll/build/iscroll-probe'
import Browser from 'aria-viewer/utils/mobileDetect'
import waitForAction from 'aria-viewer/utils/waitForAction'
import MediaContextTypes from 'aria-viewer/tour/constants/MediaContextTypes'
import { stopAudio, AUDIO_TOUR, setAudioPlaying } from 'aria-viewer/audiomanager/audioManagerActions'
import { hideAvatar } from 'aria-viewer/guide/avatarActions'
import { isAutoPlayBlocked } from 'aria-viewer/tour/tourActions'
import { setCountDown, setMute } from 'aria-viewer/audiomanager/countDownActions'
import compose from 'recompose/compose'

require('aria-viewer/tour/constants/iscroll.scss')

const ItemS = {
    currentStopBar: {
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        background: '#f5a623',
        width: 6,
        bottom: 0,
    },
    overlay: {
        transition: `background 250ms, color 250ms`,
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
    container: {
        overflow: 'hidden',
        width: 285,
        position: 'relative',
        cursor: 'pointer',
        transition: `color 250ms`,
    },
    text: {
        position: 'absolute',
        top: '50%',
        left: '32px',
        right: '32px',
        transform: 'translateY(-50%)',
        fontWeight: 400,
        fontSize: 18,
        textShadow: '0 1px 1px rgba(0, 0, 0, 0.5)',
        letterSpacing: 0,
    },
    checker: {
        display: 'block',
        width: '0.2em',
        height: '0.425em',
        borderBottom: '1px solid #fff',
        borderRight: '1px solid #fff',
        position: 'absolute',
        left: '0.125em',
        top: '-0.1em',
    },
    image: {
        transition: 'transform 250ms',
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },
    marker: {
        width: '0.6em',
        height: '0.6em',
        borderBottom: 'solid 1px #fff',
        borderLeft: 'solid 1px #fff',
        borderRight: 'solid 1px #fff',
        right: '0.7em',
        top: '0.7em',
        borderRadius: '50%',
        position: 'absolute',
        transform: 'rotate(45deg)',
    },
    badgeContainer: {
        position: 'absolute',
        height: '26px',
        width: '32px',
        borderRadius: '15px',
        top: '0.4em',
        left: '1.3em',
        zIndex: 3,
    },
    badgeStars: {
        position: 'relative',
        top: '2px',
        left: '4px',
        filter: 'brightness(0)',
        transform: 'scale(1.1)',
    },
    allTours: {
        background: '#161B24',
        color: '#FDBC48',
        padding: '6px 22px',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '18px',
        lineHeight: '34px',
        textShadow: '0px 2px 8px rgba(0, 0, 0, 0.3)',
    },
}

const animation = {
    pulse: Radium.keyframes(
        {
            '0%': { transform: 'scale(1)' },
            '25%': { transform: 'scale(1.5)' },
            '50%': { transform: 'scale(1)' },
            '75%': { transform: 'scale(1.5)' },
            '100%': { transform: 'scale(1)' },
        },
        'pulse'
    ),
}

export const showDescription = () => ({
    type: TourActions.SHOW_DESCRIPTION,
    visible: true,
})

const mapDispatchToProps = dispatch => {
    return {
        setCountDown: status => dispatch(setCountDown(status)),
        setMute: status => dispatch(setMute(status)),
    }
}

class Item extends PureComponent {
    handleClick = event => {
        this.props.onClick(this.props.index)
        this.props.setAudioPlaying(false)
        this.props.isAutoPlayBlocked(false)
        this.props.setCountDown(false)
        event.stopPropagation()
    }
    handleKeyPress = e => {
        if (e.key == 'Enter') {
            // If you press enter it should act like a click
            this.handleClick(e)
        }
    }
    onMouseIn = () => {
        if (!this.state.hover) {
            this.setState({ hover: true })
        }
    }
    onMouseOut = () => {
        if (this.state.hover) {
            this.setState({ hover: false })
        }
    }
    /* Also Handle Focus & Blur for highlighting */
    onItemFocus = e => {
        if (!this.state.hover) this.setState({ hover: true })
        //notify container of focus
        this.props.onItemFocus && this.props.onItemFocus(e)
    }
    onItemBlur = e => {
        if (this.state.hover) this.setState({ hover: false })
        //notify container of blur
        this.props.onItemBlur && this.props.onItemBlur(e)
    }
    render() {
        return (
            <>
                {this.props.index === this.props.personalizedStopsLength && (
                    <div style={ItemS.allTours}>All tour stops</div>
                )}
                <div
                    onMouseLeave={this.onMouseOut}
                    onMouseEnter={this.onMouseIn}
                    onFocus={this.onItemFocus}
                    onBlur={this.onItemBlur}
                    onKeyPress={this.handleKeyPress}
                    style={Object.assign({}, ItemS.container, {
                        height: this.props.height,
                        color: this.props.isStop || this.state.hover ? '#ffffff' : '#b4b4b4',
                    })}
                    onClick={this.handleClick}
                    className={this.props.isLastItem ? 'lastStop' : ''}
                    id={this.props.isStop ? 'activeStop' : 'stopsListItem' + this.props.index}
                    tabIndex={MAIN_SCENE_ITEM_INDEX}
                >
                    {this.props.isPersonalized && (
                        <div
                            style={Object.assign({}, ItemS.badgeContainer, {
                                background: `rgba(255, 174, 0, ${this.props.isStop || this.state.hover ? 1 : 0.7})`,
                                animation: this.props.stopDrawerCount < 1 ? 'x 3s ease-in-out' : '',
                                animationName: animation.pulse,
                            })}
                            key={this.props.index}
                        >
                            <img style={ItemS.badgeStars} src={PERSONALIZED_STARS} />
                        </div>
                    )}
                    <div
                        style={Object.assign({}, ItemS.image, {
                            backgroundImage: `url(${this.props.media.urls.tiny})`,
                            transform: `scale(${this.state.hover ? 1.2 : 1})`,
                        })}
                    >
                        <div
                            style={Object.assign({}, ItemS.overlay, {
                                background: `rgba(8, 19, 30, ${this.props.isStop || this.state.hover ? 0.4 : 0.8})`,
                            })}
                        />
                    </div>

                    {this.props.isStop && <div style={ItemS.currentStopBar} />}

                    <div
                        style={Object.assign({}, ItemS.marker, {
                            borderTop: this.props.visited ? '1px solid transparent' : '1px solid #fff',
                        })}
                    >
                        {this.props.visited && <div style={ItemS.checker} />}
                    </div>

                    <div style={ItemS.text}>{this.props.title}</div>
                </div>
            </>
        )
    }
}

const ScrollViewS = {
    stopsList: { height: '90%' },
}

class ScrollView extends PureComponent {
    constructor(props) {
        super(props)
        this.state = { mousePositionY: null }
    }

    scroll = props => {
        setTimeout(() => {
            if (this.refs.iScroll) {
                this.refs.iScroll.withIScroll(iScroll => {
                    iScroll.refresh()
                    if (props.drawerRaw.y !== -1) {
                        const stopHeight = window.innerHeight / Math.min(props.stopsList.size, 7)

                        // TODO : break down the math a little here? not sure what's going on
                        // iScroll.scrollTo(
                        //     0,
                        //     window.innerHeight * -0.8 + props.drawerRaw.y - (props.stopIndex + 0.5) * stopHeight
                        // )
                    } else if (this.props.stopIndex > 3) {
                        // if its the fourth stop or beyond, set the stop to center
                        iScroll.scrollToElement('#activeStop', 0, null, true, null)
                    } else {
                        iScroll.scrollTo(0, -window.innerHeight * 0.8)
                    }
                })
            }
        }, 0)
    }

    onScroll = iScroll => {
        if (!Browser.tablet() && this.props.supplementalMediaCarousel.size > 0) {
            const mouseY = this.state.mousePositionY ? this.state.mousePositionY : this.props.drawerRaw.y
            const cRect = this.refs.listContainer.childNodes[0].firstChild.getBoundingClientRect()
            const relY = mouseY - cRect.top
            const index = Math.floor(relY / cRect.height)
            if (index != this.lastIndex) {
                if (this.lastIndex >= 0) {
                    const c1 = this.refs['child-' + String(this.lastIndex)]
                    if (c1 && c1.onMouseOut) c1.onMouseOut()
                }
                const c2 = this.refs['child-' + String(index)]
                if (c2 && c2.onMouseIn) c2.onMouseIn()
                this.lastIndex = index
            }
        }
    }

    onScrollEnd = e => {
        this.props.stopListScrolled()
    }

    componentDidMount() {
        this.scroll(this.props)
    }

    componentWillReceiveProps(nextProps) {
        this.scroll(nextProps)
    }

    handleClick = index => {
        const stop = this.props.stopsList.get(index)

        this.props.stopListItemClicked(stop)
        this.props.setStopInitiatedBy(STOP_ANALYTICS_INITIATED_BY.scene_panel)
        this.props.setStop(index)
        this.props.hideDrawer(hideDrawerTriggers.DESTINATION_CLICKED)
    }

    onMouseOut = e => {
        requestAnimationFrame(() => this.setState({ mousePositionY: null }))
    }

    onMouseMove = e => {
        e.persist()
        requestAnimationFrame(() => this.setState({ mousePositionY: e.clientY }))
    }

    /**
     * Tabbing through StopDrawer should scroll to each item
     */
    onItemFocus = e => {
        if (this.refs.iScroll && this.refs.iScroll.getIScroll()) {
            this.refs.iScroll.getIScroll().scrollToElement(e.target, null, null, true)
        }
    }

    /**
     * Tabbing wait for last blur to close.
     */
    onItemBlur = e => {
        //If we are blurring on last item, lets call close on parent container.
        if (e.target.className.indexOf('lastStop') >= 0) {
            this.props.triggerClose && this.props.triggerClose()
        }
    }

    switchTours = e => {
        e.stopPropagation()
        const { hasMultipleToursLocations, drawer, hideDrawer, showTourDrawer } = this.props
        if (hasMultipleToursLocations) {
            if (drawer === TOUR_DRAWER) {
                hideDrawer()
            } else {
                showTourDrawer()
            }
        }
    }

    showSearchAIPrompt = () => {
        const { showSearchAIPrompt: isShown } = this.props
        if (!isShown) this.props.setShowSearchAIPrompt()
    }

    render() {
        let locationName = this.props.locationName
        const {
            setCountDown,
            setMute,
            showDescription,
            hideAvatar,
            stopAudio,
            setAudioPlaying,
            isAutoPlayBlocked,
            isSearchAIEnabled,
        } = this.props
        return (
            this.props.stopsList.size > 1 && (
                <>
                    <div style={S.locationContainer}>
                        <div style={S.locationName}>
                            {locationName?.length > 10 ? locationName.substring(0, 10) + '...' : locationName}
                            {this.props.hasMultipleToursLocations && (
                                <Button
                                    onClick={this.switchTours}
                                    style={Object.assign({}, S.caret, {
                                        cursor: this.props.hasMultipleToursLocations ? 'pointer' : 'default',
                                    })}
                                    alt="open experience selection screen"
                                    theme="caret_button"
                                >
                                    <Icon icon="arrowDown" />
                                </Button>
                            )}
                        </div>
                    </div>
                    <div
                        className="stopslist"
                        onMouseOver={this.props.onMouseOver}
                        onMouseMove={this.onMouseMove}
                        onMouseLeave={this.onMouseOut}
                        style={ScrollViewS.stopsList}
                    >
                        <div style={S.iScrollContainer}>{this.props.locationName}</div>

                        <ReactIScroll
                            ref="iScroll"
                            iScroll={iScroll}
                            onScroll={this.onScroll}
                            onScrollEnd={this.onScrollEnd}
                            options={{
                                mouseWheel: true,
                                scrollbars:
                                    this.props.drawer === STOP_FADER_DRAWER || this.props.preview ? 'custom' : false,
                                click: true,
                                probeType: 2,
                            }}
                            style={S.iScroll}
                        >
                            <div ref="listContainer">
                                <div style={S.tourLabel}>
                                    {this.props.personalizedStopsList?.size > 0 && (
                                        <>
                                            <img style={S.personalizedStars} src={PERSONALIZED_STARS} />
                                            For you
                                        </>
                                    )}
                                    {isSearchAIEnabled && (
                                        <img style={S.searchIcon} src={SEARCH_ICON} onClick={this.showSearchAIPrompt} />
                                    )}
                                </div>
                                {this.props.supplementalMediaCarousel.map((suppCar, i) => (
                                    <RadiumItem
                                        key={`${i}-${this.props.stopsList.get(i).title}`}
                                        ref={'child-' + String(i)}
                                        onItemFocus={this.onItemFocus}
                                        onItemBlur={this.onItemBlur}
                                        height={`${100 / Math.min(this.props.supplementalMediaCarousel.size, 7)}vh`}
                                        media={this.props.supplementalMediaCarousel.get(i).medias[0]}
                                        title={this.props.stopsList.get(i).title}
                                        isStop={i === this.props.stopIndex}
                                        isLastItem={i === this.props.supplementalMediaCarousel.size - 1}
                                        index={i}
                                        onClick={this.handleClick}
                                        visited={this.props.visited.get(i)}
                                        showDescription={showDescription}
                                        hideAvatar={hideAvatar}
                                        stopAudio={stopAudio}
                                        setAudioPlaying={setAudioPlaying}
                                        isAutoPlayBlocked={isAutoPlayBlocked}
                                        setCountDown={setCountDown}
                                        setMute={setMute}
                                        isPersonalized={this.props.stopsList.get(i).isPersonalized}
                                        personalizedStopsLength={this.props.personalizedStopsList?.size}
                                        stopDrawerCount={this.props.stopDrawerCount}
                                    />
                                ))}
                            </div>
                        </ReactIScroll>
                    </div>
                </>
            )
        )
    }
}

const ConnectedScrollView = compose(
    connect(
        mapSelectorsToProps([
            'drawerRaw',
            'drawer',
            'hasMultipleToursLocations',
            'visited',
            'stopIndex',
            'stopsList',
            'supplementalMediaCarousel',
            'locationName',
            'personalizedStopsList',
            'isSearchAIEnabled',
            'showSearchAIPrompt',
        ]),
        {
            showTourDrawer,
            hideDrawer,
            setStop,
            setStopInitiatedBy,
            stopListScrolled,
            stopListItemClicked,
            stopAudio,
            showDescription,
            setAudioPlaying,
            hideAvatar,
            isAutoPlayBlocked,
            setShowSearchAIPrompt,
        }
    ),
    connect(null, mapDispatchToProps)
)(ScrollView)

const RadiumItem = Radium(Item)

const S = {
    locationContainer: {
        background: '#161B24',
        padding: '24px 0 2px',
        width: '286px',
        position: 'sticky',
        top: '0px',
        zIndex: 2100,
    },
    locationName: {
        paddingBottom: '10px',
        paddingLeft: '30px',
        fontWeight: 500,
        fontSize: '32px',
        color: '#FFFFFF',
        textShadow: '0px 2px 8px rgba(0, 0, 0, 0.3)',
    },
    switchTours: {
        cursor: 'pointer',
        paddingLeft: '32px',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '18px',
        color: '#FDBC48',
        textShadow: '0px 2px 8px rgba(0, 0, 0, 0.3)',
    },
    iScrollContainer: {
        whiteSpace: 'nowrap',
        transformOrigin: '100px 100px',
        transform: 'rotate(90deg)',
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: 0.05,
        fontSize: 200,
        fontWeight: 600,
        color: 'white',
    },
    iScroll: {
        position: 'relative',
        height: '100%',
        width: '100%',
        overflow: 'visible',
    },
    tourLabel: {
        background: '#161B24',
        height: '32px',
        paddingBottom: '8px',
        paddingLeft: '32px',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '18px',
        lineHeight: '34px',
        color: '#FDBC48',
        textShadow: '0px 2px 8px rgba(0, 0, 0, 0.3)',
    },
    personalizedStars: {
        position: 'relative',
        top: '4px',
        right: '5px',
        transform: 'scale(1.2)',
    },
    searchIcon: {
        position: 'absolute',
        right: '10px',
        top: '8px',
        cursor: 'pointer',
    },
    caret: {
        paddingBottom: '0.15em',
        paddingLeft: '0.25em',
        cursor: 'pointer',
        width: '0.8125em',
        height: '0.275em',
    },
}

class StopDrawerFader extends PureComponent {
    constructor(props) {
        super(props)
        this.state = { preview: false, stopDrawerCount: 0 }
        this.hasIntro = false
        this.hasMounted = false //cannot use React's isMounted - antiPattern
    }

    componentWillReceiveProps(nextProps) {
        const { drawer, loading, supplementalMediaCarousel, close } = nextProps

        if (drawer == '|A|STOP_FADER_DRAWER') {
            this.setState({ stopDrawerCount: this.state.stopDrawerCount + 1 })
        }

        const isTourDrawerOpen = this.props.drawer == TOUR_DRAWER

        const donePreview =
            [STOP_FADER_DRAWER, HIDE_DRAWER].includes(drawer) && !loading && supplementalMediaCarousel.size > 0

        if (this.props.altMainMedia) {
            this.hasIntro = true
        }

        if ((donePreview && (isTourDrawerOpen || this.state.preview) && !nextProps.altMainMedia) || close) {
            waitForAction({ time: 2000 }).then(() => {
                if (this.hasMounted && !this.state.mouseover && this.state.preview) {
                    requestAnimationFrame(() => this.setState({ preview: false }))
                    this.handleOnClose({ hasIntro: this.hasIntro })
                    if (this.hasIntro) {
                        this.hasIntro = false
                    }
                }
            })
        }

        if (nextProps.supplementalMediaCarousel.size === 1) {
            this.setState({ preview: false })
        }
    }

    componentWillUnmount() {
        this.hasMounted = false
    }
    componentDidMount() {
        this.hasMounted = true
        setTimeout(() => this.props.hideDrawer(), 3100)
    }

    onClick = () => {
        this.setState({ preview: false })
        this.props.hideDrawer()
    }

    onMouseOver = () => {
        if (!this.state.mouseover) {
            requestAnimationFrame(() => this.setState({ preview: false, mouseover: true }))
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // if the use rmouses over the drawer lets present it.
        if (this.state.mouseover && prevState.preview) {
            requestAnimationFrame(() => this.props.showStopFaderDrawer(false, true))
        }
    }
    handleOnOpen = () => {
        this.props.onOpen && this.props.onOpen()
    }

    handleOnClose = params => {
        this.props.onClose && this.props.onClose(params)
    }

    render() {
        const { altMainMedia, skippedAltMainMedia } = this.props
        if (altMainMedia && !skippedAltMainMedia) return null

        return (
            <DrawerFader
                onClick={this.onClick}
                open={this.state.preview && !this.props.isAutoPlayEnabled}
                onOpen={this.handleOnOpen}
                onClose={this.handleOnClose}
                name={STOP_FADER_DRAWER}
                location="left"
                width="auto"
                UnmountTimeOut={styleguide.delay.normal}
                backgroundOpacity={colors.dark_blue_transparent_3}
            >
                <ConnectedScrollView
                    triggerClose={this.onClick}
                    onMouseOver={this.onMouseOver}
                    preview={this.state.preview}
                    stopDrawerCount={this.state.stopDrawerCount}
                />
            </DrawerFader>
        )
    }
}

export default connect(
    mapSelectorsToProps([
        'drawer',
        'loading',
        'supplementalMediaCarousel',
        'isAutoPlayEnabled',
        'altMainMedia',
        'skippedAltMainMedia',
        'stopIndex',
        'personalizedStopsList',
    ]),
    {
        showStopFaderDrawer,
        hideDrawer,
        hideAvatar,
    }
)(StopDrawerFader)
